import { isEqual } from "nodash"
import { RootState } from "./rootReducer"

export const combineStates = (state: RootState, incomingState: Partial<RootState>) => {
    for (const key in state) {
        const typedKey = key as keyof typeof state
        if (incomingState[typedKey] && isEqual(state[typedKey], incomingState[typedKey])) {
            delete incomingState[typedKey]
        }
    }
    return incomingState
}
